/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

// This is a facade for the observable implementation. Only import from here!

export {
	IObservable,
	IObserver,
	IReader,
	ISettable,
	ISettableObservable,
	ITransaction,
	IChangeContext } from 'vs/base/common/observableInternal/base';

export {
	observableValue,
	disposableObservableValue,
	transaction,
	subtransaction } from 'vs/base/common/observableInternal/base';
export {
	derived,
	derivedOpts,
	derivedHandleChanges,
	derivedWithStore } from 'vs/base/common/observableInternal/derived';
export {
	autorun,
	autorunHandleChanges,
	autorunWithStore,
	autorunOpts } from 'vs/base/common/observableInternal/autorun';
export {
	IObservableSignal } from 'vs/base/common/observableInternal/utils';
export {
	constObservable,
	derivedObservableWithWritableCache,
	keepObserved,
	recomputeInitiallyAndOnChange,
	observableFromEvent,
	observableSignal,
	observableSignalFromEvent } from 'vs/base/common/observableInternal/utils';
export {
	waitForState } from 'vs/base/common/observableInternal/promise';

import { ConsoleObservableLogger, setLogger } from 'vs/base/common/observableInternal/logging';

// Remove "//" in the next line to enable logging
const enableLogging = false
	// || Boolean("true") // done "weirdly" so that a lint warning prevents you from pushing this
	;

if (enableLogging) {
	setLogger(new ConsoleObservableLogger());
}
